<template>
  <section v-if="totalPages > 1">
    <ul
      class="pagination justify-content-center mb-3"
      data-cy="pagination-list">
      <li :class="['page-item', isFirstPage ? 'disabled' : '']">
        <button
          type="button"
          class="page-link"
          data-cy="pagination-first-page-button"
          @click="goTo(1)">
          «
        </button>
      </li>
      <li :class="['page-item', isFirstPage ? 'disabled' : '']">
        <button
          type="button"
          class="page-link"
          data-cy="pagination-previous-page-button"
          @click="goTo(currentPage - 1)">
          ‹
        </button>
      </li>
      <li
        v-for="page in pages"
        :key="page"
        :class="['page-item', page === currentPage ? 'active' : '']">
        <button
          type="button"
          class="page-link"
          @click="goTo(page)">
          {{ page }}
        </button>
      </li>
      <li :class="['page-item', isLastPage ? 'disabled' : '']">
        <button
          type="button"
          class="page-link"
          data-cy="pagination-next-page-button"
          @click="goTo(currentPage + 1)">
          ›
        </button>
      </li>
      <li :class="['page-item', isLastPage ? 'disabled' : '']">
        <button
          type="button"
          class="page-link"
          data-cy="pagination-last-page-button"
          @click="goTo(totalPages)">
          »
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
/**
 * Pagination for REST-backed overviews. Mirrors the parent-facing API of PaginationAlgolia
 * (`refresh()`, `redirect(page)`, `@changed-page`) so migrated views keep their `$refs` usage,
 * but the page number is owned by the parent instead of an InstantSearch widget.
 */
export default {
  name: 'PaginationRest',
  props: {
    /** 1-based. */
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 0
    },
    /** How many numbered page links to render around the current page. */
    windowSize: {
      type: Number,
      default: 7
    }
  },
  computed: {
    isFirstPage() {
      return this.currentPage <= 1
    },
    isLastPage() {
      return this.currentPage >= this.totalPages
    },
    pages() {
      const size = Math.min(this.windowSize, this.totalPages)
      let start = Math.max(1, this.currentPage - Math.floor(size / 2))
      if (start + size - 1 > this.totalPages) {
        start = this.totalPages - size + 1
      }
      return Array.from({ length: size }, (_, index) => start + index)
    }
  },
  methods: {
    goTo(page) {
      const target = Math.min(Math.max(page, 1), this.totalPages)
      if (target === this.currentPage) {
        return
      }
      this.$emit('changed-page', target)
    },
    refresh() {
      this.$emit('changed-page', 1)
    },
    redirect(page) {
      const parsed = parseInt(page)
      this.goTo(isNaN(parsed) ? 1 : parsed)
    }
  }
}
</script>
